import { createFileRoute } from "@tanstack/react-router";

import { NetsuiteSuiteanalyticsFormPage } from "~/pages/connection-new/netsuite-suiteanalytics-form.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/_connection/netsuite_suiteanalytics",
)({
  component: NetsuiteSuiteanalyticsFormPage,
});
